/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

/**
 * Get file extension for determining icon display
 * Returns the file extension if it's supported, otherwise 'default'
 * @param filename - The filename to extract extension from
 * @returns The extension (lowercase) or 'default'
 */
export function getFileExtension(filename: string): string {
  const supportedExts = [
    'doc',
    'docx',
    'xls',
    'xlsx',
    'txt',
    'ai',
    'psd',
    'eps',
    'jpg',
    'jpeg',
    'pdf',
    'png',
    'ppt',
    'pptx'
  ]

  const ext = filename ? String(filename.split('.').pop()).toLowerCase() : null

  if (!ext || supportedExts.indexOf(ext) === -1) {
    return 'default'
  }

  return ext
}
